export default {
  data() {
    return {
      showPrivateNotification: false
    };
  },
};
